export const performancePrintStyles = `
  [data-performance-print-root] { display: none; }
  @media print {
    @page { size: A4 portrait; margin: 14mm 12mm; }
    html, body { height: auto !important; overflow: visible !important; background: #fff !important; }
    body > *:not([data-performance-print-root]) { display: none !important; }
    body > [data-performance-print-root] {
      display: block !important; position: static !important; width: auto !important;
      color: #25212b; background: #fff; font: 10pt/1.4 Arial, sans-serif;
      print-color-adjust: exact; -webkit-print-color-adjust: exact;
    }
    [data-performance-print-root] * { box-sizing: border-box; }
    [data-performance-print-root] h1 { font-size: 19pt; line-height: 1.2; color: #542096; margin: 0 0 5mm; }
    [data-performance-print-root] h2 { font-size: 13pt; margin: 7mm 0 3mm; break-after: avoid; }
    [data-performance-print-root] h3 { font-size: 10pt; margin: 4mm 0 2mm; break-after: avoid; }
    [data-performance-print-root] p { margin: 2mm 0; orphans: 3; widows: 3; }
    [data-performance-print-root] dl { display: grid; grid-template-columns: 40mm 1fr; margin: 0 0 5mm; }
    [data-performance-print-root] dt, [data-performance-print-root] dd { margin: 0; padding: 1mm 0; overflow-wrap: anywhere; }
    [data-performance-print-root] dt { font-weight: bold; padding-right: 3mm; }
    [data-performance-print-root] table {
      width: 100%; border-collapse: collapse; table-layout: fixed; margin: 2mm 0 4mm; font-size: 9pt;
    }
    [data-performance-print-root] thead { display: table-header-group; }
    [data-performance-print-root] tr { break-inside: avoid; }
    [data-performance-print-root] th, [data-performance-print-root] td {
      text-align: left; vertical-align: top; border-bottom: .2mm solid #d8d1df;
      padding: 2mm; overflow-wrap: anywhere; font-variant-numeric: tabular-nums;
    }
    [data-performance-print-root] th { background: #f1eaf8; font-weight: bold; }
    [data-performance-print-root] .performance-print-warning { border-left: 1mm solid #98572a; padding: 1mm 3mm; }
    [data-performance-print-root] .performance-print-note { font-size: 9pt; color: #514959; }
    [data-performance-print-root] footer { border-top: .2mm solid #d8d1df; margin-top: 6mm; padding-top: 2mm; font-size: 9pt; }
  }
`;
